import type { CreateEmbryoFreezingPlanInput } from "./hooks/useEmbryoFreezingPlans";

export type EmbryoFreezingSourceChoice =
  "own" | "donor_eggs" | "donor_sperm" | "donor_both" | "not_sure";

export function createMinimalEmbryoFreezingPlanInput(
  clientRequestId: string,
  sourceChoice: EmbryoFreezingSourceChoice = "own",
): CreateEmbryoFreezingPlanInput {
  const sourceKinds = {
    own: { oocyte: "self", semen: "self" },
    donor_eggs: { oocyte: "donor", semen: "self" },
    donor_sperm: { oocyte: "self", semen: "donor" },
    donor_both: { oocyte: "donor", semen: "donor" },
    not_sure: { oocyte: "unknown", semen: "unknown" },
  } as const;
  const selectedSources = sourceKinds[sourceChoice];
  const isSourceUnresolved = sourceChoice === "not_sure";

  return {
    viewerRole: "patient",
    oocyteSourceKind: selectedSources.oocyte,
    oocyteSourceStatus: isSourceUnresolved ? "unknown" : "patient_reported",
    oocyteMaterialState: "unknown",
    semenSourceKind: selectedSources.semen,
    semenSourceStatus: isSourceUnresolved ? "unknown" : "patient_reported",
    semenMaterialState: "unknown",
    fertilizationMethod: "not_yet_applicable",
    pgtPlan: "undecided",
    clientRequestId,
    status: isSourceUnresolved ? "awaiting_source_decision" : "draft",
  };
}
